import "es6-shim";
import "../Overview.css";
import * as React from 'react';
import { IOrientationProps } from "../Types";
import { MediaOrientation } from "../../../hooks/useMediaQuery.hook";

interface IDataTableRenderProps {
    textTitle: string,
    addText: string,
    editText: string;
    dataArray: any[],
    deleteText: string,
    removeLeftPadding?: boolean,
    canModify?: boolean,
    dataToRender?(data: any, renderIcon: boolean): JSX.Element,
    onEditItem(): void,
    onDeleteItem?(index: number): void,
    addNewItem?(length: number): void,
}

export const DataTableRender = (props: IDataTableRenderProps & IOrientationProps) => {
    return (
        <div>
            <div>
                <table className="table">
                    <thead>
                        <tr>
                            <th colSpan={2}>
                                <span className="category-title">
                                    {props.textTitle}
                                </span>
                                {
                                    props.canModify &&
                                    <button style={{ float: "right" }} className="buttons-white-smaller" onClick={() => props.onEditItem()}>
                                        {
                                            props.editText
                                        }
                                    </button>
                                }
                            </th>
                        </tr>
                    </thead>
                </table>
            </div>
            <div>
                <table className="table">
                    <tbody>
                        {
                            props.orientation === MediaOrientation.Portrait
                                ? props.dataArray.map((data, index) => {
                                    return (
                                        <tr className="data-table-render" key={"dataTableRender" + index}>
                                            <td>
                                                <div>{props.dataToRender(data, true)}</div>
                                            </td>
                                        </tr>
                                    )
                                })
                                : <tr>
                                    <td style={{ display: "flex" }}>
                                        <div className="data-table-render">
                                            {props.dataArray.map((data, index) => props.dataToRender(data, true))}
                                        </div>
                                    </td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/PatientOverview/SubComponents/DataTableRender.tsx